module.exports = {"1":"Bardzo słaba","2":"Słaba","3":"Średnia","4":"Dobra","5":"Doskonała","1.5":"Bardzo słaba","2.5":"Słaba","3.5":"Średnia","4.5":"Doskonała"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/pl-PL/star-ratings.json
// module id = 1326
// module chunks = 0